export enum ContractStatus {
    TERMINATION_BOOKMARKED = 'TERMINATION_BOOKMARKED',
    /* Not yet in use: */
    CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
    DUNNING = 'DUNNING',
    ORDERED = 'ORDERED',
}
